/**
 * LE DERNIER FORMAT D'ÉTIQUETTE IMPRIMÉ SUR CE POSTE — repris à l'impression suivante, dans l'onglet Imprimer des
 * Étiquettes comme dans la fenêtre d'étiquettes d'une réception.
 *
 * ⚠️ RETENU PAR LE NAVIGATEUR, PAS PAR LE COMPTE : le format suit l'imprimante raccordée au poste (rouleau à la réserve,
 *    planche A4 au bureau). Un réglage de compte imposerait le rouleau au poste qui n'a qu'une imprimante A4.
 * ⚠️ PAR MAGASIN : chaque magasin a ses gabarits, une clé venue d'un autre ne désignerait rien.
 * ⚠️ UN CONFORT, JAMAIS UNE DONNÉE : stockage indisponible (navigation privée, données effacées) ou gabarit masqué ou
 *    supprimé depuis → le premier gabarit visible, comme sans mémoire.
 */

const KEY_PREFIX = 'oz.labels.last-template.';

/** Le stockage du navigateur, ou `null` quand il n'est pas accessible. */
function storage(): Storage | null {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
}

/** Le dernier gabarit imprimé sur ce poste pour ce magasin, s'il est encore parmi ceux proposés — sinon `null`. */
export function lastLabelTemplate(gln: string | null, templates: readonly { key: string }[]): string | null {
  if (!gln) return null;
  try {
    const key = storage()?.getItem(KEY_PREFIX + gln) ?? null;
    return key && templates.some((tpl) => tpl.key === key) ? key : null;
  } catch {
    return null;
  }
}

/** Retient le gabarit qui vient de servir à imprimer. Un stockage refusé ne gêne pas l'impression : il ne retient rien. */
export function rememberLabelTemplate(gln: string | null, key: string): void {
  if (!gln || !key) return;
  try {
    storage()?.setItem(KEY_PREFIX + gln, key);
  } catch {
    // Stockage plein ou interdit : la prochaine impression repartira du premier gabarit, rien de plus.
  }
}
